export default "__VITE_ASSET__DCs3Grkv__"